/**
 * @generated SignedSource<<a7e557a765c0bc46d468308197e2451f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkstreamActivateMutation$variables = {
  id: number;
};
export type WorkstreamActivateMutation$data = {
  readonly activateWorkstream: {
    readonly workstream: {
      readonly archived: boolean;
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type WorkstreamActivateMutation = {
  response: WorkstreamActivateMutation$data;
  variables: WorkstreamActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UpdateWorkstreamResult",
    "kind": "LinkedField",
    "name": "activateWorkstream",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "workstreams",
        "kind": "LinkedField",
        "name": "workstream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkstreamActivateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkstreamActivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b5f41fb1485f536e139bbe7c2818744",
    "id": null,
    "metadata": {},
    "name": "WorkstreamActivateMutation",
    "operationKind": "mutation",
    "text": "mutation WorkstreamActivateMutation(\n  $id: Int!\n) {\n  activateWorkstream(id: $id) {\n    workstream {\n      id\n      name\n      archived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3371ebabf9bd1551106674a6df8d387c";

export default node;
